// Libs
import { createSelector } from 'reselect'
import _keys from 'lodash/keys'

import tableOperations$ from './tableOperations'

export default createSelector(
  [
    tableOperations$,
  ],
  (operations) => {
    const firstKey = _keys(operations)[0]

    if (firstKey) {
      return operations[firstKey]
    }

    return null
  }
)
